"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yuzuswap = void 0;
exports.yuzuswap = {
    router: '0x250d48C5E78f1E85F7AB07FEC61E93ba703aE668',
    masterchef: '0xB759803Ee7087559EB601a4939c2d5da7668385a',
};
